import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PullDetail } from '@/features/pulls/components/pull-detail';
import { pullFilesQuery } from '@/features/pulls/services/pulls';
import { walkThroughQuery } from '@/services/walkthrough';

const paramsSchema = z.object({
  owner: z.string(),
  repo: z.string(),
  number: z.coerce.number().int().positive(),
});

export const Route = createFileRoute('/_authed/_layout/$owner/$repo/pull/$number')({
  component: () => {
    return <PullDetail />;
  },
  params: { parse: (params) => paramsSchema.parse(params) },
  loader: async ({ context: { queryClient }, params: { owner, repo, number } }) => {
    queryClient.prefetchQuery(pullFilesQuery(owner, repo, number));
    queryClient.prefetchQuery(walkThroughQuery(owner, repo, number));
  },
});
